export default "__VITE_ASSET__dLaxIbzR__"